import { gql, TypedDocumentNode } from '@apollo/client';

import { CityWithJobCount, QueryJobCountByCitiesArgs } from '@pflegia/data-access';

export const GET_JOB_COUNT_BY_CITIES: TypedDocumentNode<{ cities: CityWithJobCount[] }, QueryJobCountByCitiesArgs> = gql`
  query jobCountByCities($cities: [String!]!) {
    cities: jobCountByCities(cities: $cities) {
      city
      jobCount
    }
  }
`;
